import React from "react";
import "./CategoriesSection.scss";

const CategoriesSection = () => {
  const categories = [
    {
      title: "Centros de maquinado CNC",
      text: "Equipos CNC para procesos de precisión, productividad y alto rendimiento en manufactura industrial.",
    },
    {
      title: "Tornos CNC",
      text: "Soluciones para maquinado y producción con equipos orientados a operación continua y resultados consistentes.",
    },
    {
      title: "Rectificadoras",
      text: "Maquinaria especializada para trabajos que requieren exactitud, acabado fino y control dimensional.",
    },
    {
      title: "Láser industrial",
      text: "Equipos para corte y trabajo industrial con enfoque en eficiencia, velocidad y precisión.",
    },
    {
      title: "Compresores",
      text: "Soluciones de soporte industrial para operación de maquinaria y procesos que requieren aire comprimido.",
    },
    {
      title: "Montacargas",
      text: "Equipos para movimiento y manejo de carga dentro de procesos industriales y logísticos.",
    },
  ];

  return (
    <section className="categories-section" id="categorias">
      <div className="container">
        <div className="categories-section__heading">
          <div className="categories-section__eyebrow">Categorías</div>

          <h2 className="categories-section__title">
            Maquinaria industrial para distintas necesidades de operación,
            producción y trabajo especializado.
          </h2>

          <p className="categories-section__subtitle">
            Encuentra la maquinaria ideal para cada etapa de tu producción;
            contamos con equipos especializados que responden a distintas
            necesidades operativas, ofreciendo precisión, eficiencia y
            confiabilidad en cada proceso. ¿No lo tenemos? Lo conseguimos. En
            MAKINARIA DIMA siempre encontramos la solución para tu operación.
          </p>
        </div>

        <div className="categories-section__grid">
          {categories.map((item, index) => (
            <article className="categories-section__card" key={index}>
              <div className="categories-section__icon">
                <span></span>
              </div>

              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;
